import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getTestimonials } from '../../api/services';
import './Testimonials.css';

function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  const renderStars = (rating) => '★'.repeat(rating) + '☆'.repeat(5 - rating);

  useEffect(() => {
    getTestimonials().then(res => {
      if (res.success) {
        // Only show first 4 on homepage
        setTestimonials(res.data.slice(0, 4));
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const openModal = (testimonial) => {
    setSelected(testimonial);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelected(null);
    document.body.style.overflow = 'auto';
  };

  if (loading) return (
    <section className="section testimonials-section">
      <div className="container">Loading...</div>
    </section>
  );

  return (
    <section id="testimonials" className="section testimonials-section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Testimonials</span>
          <h2 className="section-title">What Our Clients Say</h2>
          <p className="section-subtitle">Real stories from satisfied customers</p>
        </div>
        <div className="testimonials-grid">
          {testimonials.length === 0 ? (
            <p className="no-data">No testimonials added yet.</p>
          ) : (
            testimonials.map((testimonial) => (
              <div 
                key={testimonial.id} 
                className="testimonial-card" 
                onClick={() => openModal(testimonial)}
                style={{ cursor: 'pointer' }}
              >
                <div className="testimonial-header">
                  {testimonial.client_photo ? (
                    <img 
                      src={testimonial.client_photo} 
                      alt={testimonial.client_name} 
                      className="testimonial-avatar" 
                    />
                  ) : (
                    <div className="testimonial-avatar-placeholder">
                      {testimonial.client_name.charAt(0)}
                    </div>
                  )}
                  <div className="testimonial-author-info">
                    <div className="testimonial-author">
                      <strong>{testimonial.client_name}</strong>
                      {testimonial.designation && <span> — {testimonial.designation}</span>}
                    </div>
                    {testimonial.company && (
                      <div className="testimonial-company">{testimonial.company}</div>
                    )}
                    <div className="testimonial-stars">{renderStars(testimonial.rating)}</div>
                  </div>
                </div>
                <p className="testimonial-text">"{testimonial.message}"</p>
                {testimonial.gallery_images && testimonial.gallery_images.length > 0 && (
                  <div className="testimonial-gallery-thumbs">
                    {testimonial.gallery_images.slice(0, 3).map((img, index) => (
                      <img key={index} src={img} alt={`Gallery ${index}`} className="testimonial-gallery-thumb" />
                    ))}
                    {testimonial.gallery_images.length > 3 && (
                      <span className="testimonial-gallery-more">+{testimonial.gallery_images.length - 3}</span>
                    )}
                  </div>
                )}
              </div>
            ))
          )}
        </div>

        {/* View All Button */}
        <div className="testimonials-view-all">
          <Link to="/testimonials" className="btn-view-all">
            View All Testimonials →
          </Link>
        </div>
      </div>

      {/* Modal */}
      {selected && (
        <div className="testimonial-modal-overlay" onClick={closeModal}>
          <div className="testimonial-modal" onClick={(e) => e.stopPropagation()}>
            <button className="testimonial-modal__close" onClick={closeModal}>✕</button>
            
            <div className="testimonial-modal__header">
              {selected.client_photo ? (
                <img src={selected.client_photo} alt={selected.client_name} className="testimonial-modal__avatar" />
              ) : (
                <div className="testimonial-modal__avatar-placeholder">
                  {selected.client_name.charAt(0)}
                </div>
              )}
              <div>
                <h3>{selected.client_name}</h3>
                {selected.designation && <p>{selected.designation}</p>}
                {selected.company && <p className="testimonial-modal__company">{selected.company}</p>}
                <div className="testimonial-modal__stars">{renderStars(selected.rating)}</div>
              </div>
            </div>

            <p className="testimonial-modal__message">{selected.message}</p>

            {selected.gallery_images && selected.gallery_images.length > 0 && (
              <div className="testimonial-modal__gallery">
                <h4>Project Gallery</h4>
                <div className="testimonial-modal__gallery-grid">
                  {selected.gallery_images.map((img, index) => (
                    <img key={index} src={img} alt={`Gallery ${index}`} />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
}

export default Testimonials;